import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheet } from '@/components/action-sheet';

interface Props {
  isSaving: boolean;
  isVisible: boolean;
  onDiscard: () => void;
  onDismiss: () => void;
  onSaveFromSheet: () => void | Promise<void>;
}

export const DiscardChangesConfirmationActionSheet: React.FC<Props> = ({
  isSaving,
  isVisible,
  onDiscard,
  onDismiss,
  onSaveFromSheet,
}) => {
  const handleAction = async (_: string, index: number) => {
    if (index === 0) {
      await onSaveFromSheet();
      return;
    }
    onDiscard();
  };

  return (
    <ActionSheet
      actions={[i18n.t('save'), i18n.t('dont_save_and_exit')]}
      isVisible={isVisible}
      loadingActionIndex={isSaving ? 0 : null}
      message={i18n.t('discard_changes_disclaimer')}
      onAction={handleAction}
      onClose={onDismiss}
      title={i18n.t('action_sheet.save.title')}
    />
  );
};
